import { render, staticRenderFns } from "./GroupTabHeroes.vue?vue&type=template&id=62646be1&scoped=true&"
import script from "./GroupTabHeroes.vue?vue&type=script&lang=js&"
export * from "./GroupTabHeroes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62646be1",
  null
  
)

export default component.exports